import { createFileRoute } from "@tanstack/react-router";
import AdminRedirects from "@/pages/admin/AdminRedirects";

export const Route = createFileRoute("/_adminLayout/admin/redirects")({
  component: AdminRedirects,
});
